import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';

export default function useQueryString(): [ParsedUrlQuery, (q: ParsedUrlQuery) => void] {
  const router = useRouter();
  const { query } = router;

  const setQuery = useCallback(
    (query) => {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, ...query },
      });
    },
    [router]
  );

  return [query, setQuery];
}
